import InnerBox from '@repo/ui/inner-box'
import MultiSelectInput from '@repo/ui/multiselect-input'
import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { getHobbies } from '../../../api/hobbies/get-hobbies'
import { HobbyAudienceEnum } from '../../../lib/types/enums/hobby/hobby-audience.enum'
import { StaffApplicationInput } from '../../../lib/types/models/staff-application/staff-application-input'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'

const StaffApplicationFormHobbies = () => {
  const form = useFormContext<StaffApplicationInput>()

  const { data: hobbies } = useQuery({
    queryKey: ['hobbies', { automaticallyGenerated: false, visibleTo: [HobbyAudienceEnum.STAFF] }],
    queryFn: () =>
      getHobbies({
        filter: { automaticallyGenerated: false, visibleTo: [HobbyAudienceEnum.STAFF] }
      })
  })

  return (
    <InnerBox title="Loisirs">
      <FormField
        control={form.control}
        name="hobbiesId"
        render={({ field }) => (
          <FormItem className="flex-1">
            <FormControl>
              <MultiSelectInput
                {...field}
                label="Loisirs"
                variant="primary"
                searchable
                options={
                  hobbies?.data?.map((hobby) => ({
                    label: hobby.name,
                    value: hobby.id
                  })) || []
                }
                selectedOptions={
                  field.value?.map((id) => ({
                    label: hobbies?.data?.find((hobby) => hobby.id === id)?.name || '',
                    value: id
                  })) || []
                }
              />
            </FormControl>
          </FormItem>
        )}
      />
    </InnerBox>
  )
}

export default StaffApplicationFormHobbies
